import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import BaseComponent from 'foundation/base-component';
import store from 'general/js/store';
import LiveTextWidgetLayout from './live-text-widget-layout';

class LiveTextWidget extends BaseComponent {
    constructor(...args) {
        super(...args);
        this.init();
    }

    init() {
        this.render();
    }

    onDestroy() {
        ReactDOM.unmountComponentAtNode(this.element);
    }

    render() {
        ReactDOM.render(
            <Provider store={store}>
                <LiveTextWidgetLayout options={this.options} />
            </Provider>,
            this.element
        );
    }
}

export default LiveTextWidget;
